import React from 'react';

//Redux
import { useDispatch, useSelector } from 'react-redux';

//Swal
import Swal from 'sweetalert2';

//Actions
import {
    activeVariants,
    productEdit,
    setProductCatalogStatus
} from '../../../../actions/product';

//MUI
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import ArchiveIcon from '@mui/icons-material/Archive';
import RestoreIcon from '@mui/icons-material/Restore';
import EditIcon from '@mui/icons-material/Edit';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';

const ProductListMenu = ({ anchorEl, setAnchorEl, setOpenDrawer }) => {
    const dispatch = useDispatch();
    const { active } = useSelector(state => state.product);
    const {
        _id, title, folderId, prod_variants,
        catalog_status
    } = active;
    
    const open = Boolean(anchorEl);

    // editar producto
    const editProduct = () => {
        setAnchorEl(null);
        dispatch(productEdit());
    };

    const changeProductStatus = () => {
        setAnchorEl(null);
        const archived = catalog_status === 'archived';
        Swal.fire({
            title: archived
                ? `¿Deseas restaurar ${title}?`
                : `¿Deseas retirar ${title} de la tienda?`,
            text: archived
                ? 'Volverá a mostrarse en el catálogo que le corresponda.'
                : 'Se conservarán variantes, imágenes, reseñas e historial.',
            showDenyButton: true,
            confirmButtonText: archived ? 'Restaurar' : 'Retirar',
            denyButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(setProductCatalogStatus(
                    _id,
                    archived ? 'restore' : 'archive'
                ));
            }
        });
    };

    //Lista de variantes
    const variantList = () => {
        dispatch(activeVariants({
            prod_id: _id, title, folderId,
            variants: prod_variants
        }));
        setAnchorEl(null);
        setOpenDrawer(true)
    };

    // cerrar menú
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Menu id="product-list-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-settings',
            }}>
            <MenuItem onClick={editProduct}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Editar</ListItemText>
            </MenuItem>
            <MenuItem onClick={changeProductStatus}>
                <ListItemIcon>
                    {catalog_status === 'archived'
                        ? <RestoreIcon fontSize="small" />
                        : <ArchiveIcon fontSize="small" />}
                </ListItemIcon>
                <ListItemText>
                    {catalog_status === 'archived' ? 'Restaurar' : 'Retirar de la tienda'}
                </ListItemText>
            </MenuItem>
            <MenuItem onClick={variantList}>
                <ListItemIcon>
                    <AutoAwesomeMotionIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Mostrar variantes</ListItemText>
            </MenuItem>
        </Menu>
    );
};

export default ProductListMenu;
